import React, { useEffect } from 'react';
import { Xmark, WarningTriangle } from 'iconoir-react';

interface CardQuotaWarningToastProps {
  onClose: () => void;
  autoDismissMs?: number;
}

// Toast non bloquant, réutilise le style de StorageWarningToast (mêmes classes
// CSS génériques, cf. index.css). Affiché uniquement au franchissement du
// seuil de 90% du quota GLOBAL de cartes (cf. CardController::store /
// OverageService::checkCardQuotaWarning), jamais à chaque carte créée
// au-dessus de ce seuil : la décision est déjà prise côté backend, ce
// composant se contente de l'afficher puis de s'auto-fermer.
export const CardQuotaWarningToast: React.FC<CardQuotaWarningToastProps> = ({
  onClose,
  autoDismissMs = 6000,
}) => {
  useEffect(() => {
    const timer = setTimeout(onClose, autoDismissMs);
    return () => clearTimeout(timer);
  }, [onClose, autoDismissMs]);

  return (
    <div className="storage-warning-toast">
      <WarningTriangle width={20} height={20} strokeWidth={2} color="#ff4d4d" />
      <div className="storage-warning-toast-body">
        <strong>Vous avez utilisé 90 % de votre quota de cartes.</strong>
      </div>
      <button className="storage-warning-toast-close" onClick={onClose} title="Fermer">
        <Xmark width={16} height={16} strokeWidth={2} />
      </button>
    </div>
  );
};
